(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-discovered"] && !Shopify.designMode) return;
  try {
    
  function mountWPDiscovery(root) {
    root.querySelectorAll('[data-wpi-switcher]').forEach(function (switcher) {
      if (switcher.dataset.wpiReady) return;
      switcher.dataset.wpiReady = 'true';
      switcher.querySelectorAll('[data-wpi-choice]').forEach(function (button) {
        button.addEventListener('click', function () {
          switcher.querySelectorAll('[data-wpi-choice]').forEach(function (choice) {
            choice.setAttribute('aria-pressed', choice === button ? 'true' : 'false');
          });
          switcher.querySelectorAll('[data-wpi-frame]').forEach(function (frame) {
            frame.hidden = frame.dataset.wpiFrame !== button.dataset.wpiChoice;
          });
          switcher.querySelector('[data-wpi-finish]').textContent = button.dataset.wpiTitle;
          switcher.querySelector('[data-wpi-observation]').textContent = button.dataset.wpiObservationCopy;
          switcher.querySelector('[data-wpi-price]').textContent = button.dataset.wpiPrice;
          switcher.querySelector('[data-wpi-product-link]').href = button.dataset.wpiUrl;
        });
      });
    });
  }
  mountWPDiscovery(document);
  document.addEventListener('shopify:section:load', function (event) { mountWPDiscovery(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrist-pinnacle-discovery"] && !Shopify.designMode) return;
  try {
    
  function mountDiscovery(section) {
    if (section.dataset.discoveryMounted) return;
    section.dataset.discoveryMounted = 'true';
    const choices = section.querySelectorAll('[data-discovery-choice]');
    const panels = section.querySelectorAll('[data-discovery-panel]');
    function show(id) {
      choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.discoveryChoice === id)));
      panels.forEach(panel => { panel.hidden = panel.dataset.discoveryPanel !== id; });
    }
    choices.forEach(button => button.addEventListener('click', () => show(button.dataset.discoveryChoice)));
    section.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('[data-discovery-panel]');
      if (panel) show(panel.dataset.discoveryPanel);
    });
  }
  document.querySelectorAll('[data-wp-discovery]').forEach(mountDiscovery);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wp-discovery]').forEach(mountDiscovery));

  } catch(e) { console.error(e); }
})();
})();
